export default function ($translate) {
    return {
        KEYS: {
            PUBLISHED: 'PUBLISHED',
            UNPUBLISHED: 'UNPUBLISHED',
            CANCELLED: 'CANCELLED'
        },
        LABELS: {
            PUBLISHED: $translate.instant('occurrence.published'),
            UNPUBLISHED: $translate.instant('occurrence.unpublished'),
            CANCELLED: $translate.instant('occurrence.cancelled')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/occurrence/status/index.js